import { render, staticRenderFns } from "./FormularioAliadoEditar.vue?vue&type=template&id=6afe12aa&scoped=true"
import script from "./FormularioAliadoEditar.vue?vue&type=script&lang=js"
export * from "./FormularioAliadoEditar.vue?vue&type=script&lang=js"
import style0 from "./FormularioAliadoEditar.vue?vue&type=style&index=0&id=6afe12aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afe12aa",
  null
  
)

export default component.exports